module.exports = __webpack_public_path__ + "assets/85f1e98bfd79a95710199ec18497836f.png";